var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],class:_vm.btnClass,attrs:{"type":_vm.type,"title":_vm.title},on:{"click":function($event){return _vm.click()}}},[_c('i',{staticClass:"mdi mdi-plus"}),_vm._v(" "+_vm._s(_vm.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }